var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('apex-chart',{staticClass:"scatter-chart",attrs:{"height":"80%","type":"scatter","series":_vm.series,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }